export default __webpack_public_path__ + "static/media/extruding.c35e64eb.svg";